import React from 'react';
import './Sections.css';

const Section3 = () => {
  const features = [
    {
      title: "Pay subcontractors fast",
      description: "Run all your payments in a couple of clicks — instant bank transfers, no delays."
    },
    {
      title: "Online timesheets",
      description: "Track work and hours in one place — no chasing, no spreadsheets, no headaches."
    },
    {
      title: "Verify and set up subbies",
      description: "HMRC verification and contracts sorted automatically with digital signatures."
    },
    {
      title: "CIS deductions & returns",
      description: "Calculated and submitted automatically — all done for you, fully compliant."
    }
  ];

  return (
    <section className="section-3">
      <div className="paycis-container">
        <h3 className="section-3-headline">
          Payroll software built for your <br />
          construction business
        </h3>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <h4 className="feature-title">{feature.title}</h4>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Section3;